import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import styles from './styles.module.css';

@autobind
export default class SocialButton extends Component {
    static propTypes = {
        color: PropTypes.oneOf(['default', 'primary']),
        circular: PropTypes.bool,
    };

    static defaultProps = {
        color: 'default',
    };

    render() {
        const className = classNames(
            styles[this.props.provider],
            styles[`color-${this.props.color}`],
            this.props.circular && styles.circular
        );

        return (
            <div className={styles.container}>
                <button className={className} {...this.props}>
                    <div className={styles.icon} />
                    {this.props.children}
                </button>
            </div>
        );
    }
}
